import Router from 'vue-router';
import Vue from 'vue';
import news from '@/pages/news';
import comBasic from '@/pages/commonTemp'
import tags from '@/pages/tags';
import historic_records from '@/pages/historic_records';
import iframe_box from '@/pages/iframe_box';
Vue.use(Router)
const router = new Router({
	// mode: 'history',
    routes: [
		{
			path: '/pages',
			name: 'comBasic',
			component: comBasic,
			// children: [
			// 	{
			// 		path: 'tags',
			// 		name: 'tags',
			// 		component: tags
			// 	}, {
			// 		path: 'news',
			// 		name: 'news',
			// 		component: news
			// 	}, {
			// 		path: 'historic_records',
			// 		name: 'historic_records',
			// 		component: historic_records
			// 	}, {
			// 		path: 'iframe_box',
			// 		name: 'iframe_box',
			// 		component: iframe_box
			// 	}
			// ]
		}
    ]
})

router.beforeEach((to, from, next) => {
	console.group('路由变化')
	console.groupEnd('路由变化')
	next()
})

export default router
